export const L10N = {
  NOTIFICATION_ERROR: { id: 'common.notification.error_unknown' },
};
